import styled from 'styled-components'

import CardContainer from 'live/components/ui/CardContainer'

import { bowtieTheme } from '../../utils/constants'
import { Scrollbars } from '../Scrollbars/Scrollbars'

export const EntityErrorScrollbars = styled(Scrollbars)`
    .ScrollbarsCustom-Track.ScrollbarsCustom-TrackY {
        right: 5px !important;
    }

    .ScrollbarsCustom-Content {
        padding: 16px !important;
    }
`

export const ListCard = styled(CardContainer)`
    position: relative;
    padding: 0px;
    border: none;
    margin-bottom: 4px;

    &:hover {
        background-color: ${({ theme }) => theme['blue-200']};
    }

    .custom-card {
        display: flex;
        flex-direction: row;

        &.clickable {
            cursor: pointer;
        }

        .custom-card-border {
            border-radius: 3px 0px 0px 3px;
            display: flex;
            flex-direction: column;
            padding: 0;

            &.BARRIER,
            &.ESCALATIONBARRIER {
                border-left: 8px solid ${bowtieTheme.barrierColors.active};
            }

            &.ESCALATIONFACTOR {
                border-left: 8px solid ${bowtieTheme.escalation};
            }

            &.HAZARD {
                width: 8px;
                background: repeating-linear-gradient(45deg, #000000 0px, #000000 5px, #ffe600 5px, #ffe600 10px);
            }

            &.TOPEVENT {
                border-left: 8px solid #f1ddbe;
            }

            &.THREAT {
                border-left: 8px solid #3866b1;
            }

            &.CONSEQUENCE {
                border-left: 8px solid #8768a3;
            }
        }

        .custom-card-content {
            display: flex;
            flex-direction: column;
            padding: 0;
            background: none;
            flex-grow: 1;
            border: 1px solid ${({ theme }) => theme['gray-400']};
            border-radius: 0px 3px 3px 0px;
            padding-right: 20px;

            .custom-card-header {
                display: flex;
                flex-direction: row;
                flex-grow: 1;
                padding-left: 8px;
                padding-right: 8px;
                padding-bottom: 2px;
                padding-top: 8px;

                .custom-card-title {
                    color: ${({ theme }) => theme['gray-900']};
                    font-family: ${({ theme }) => theme['font-bold']};
                }

                .custom-card-id {
                    color: ${({ theme }) => theme['gray-700']};
                    margin-left: 4px;
                }
            }

            .custom-card-description {
                padding-left: 8px;
                padding-right: 8px;
                padding-bottom: 8px;
                padding-top: 2px;
                display: flex;
                flex-direction: row;
                color: ${({ theme }) => theme['gray-700']};
                font-size: 12px;
            }
        }
    }

    header {
        display: none;
    }
`
